import { computed, ref, watch, onMounted } from "vue";

export default {
    name: "AmountSelector",
    props: {
        id: {
            type: String,
            required: false,
            default: 'amountSelector'
        },
        sku: {
            type: String,
        },
        label: {
            type: String,
            default: "Antal"
        },
        maxAmount: {
            type: Number,
        },
        minAmount: {
            type: Number,
            default: 1,
        },
        startAmount: {
            type: Number,
        },
        displayMessage: {
            type: Function,
            required: true,
        },
        setAmount: {
            type: Function,
            required: true,
        },
        doNotUseInputValidation: {
            type: Boolean,
            required: false,
            default: false,
        },
        ariaDescribedby: {
            type: String,
            required: false
        },
        readOnly: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props) {
        const amount = ref(
            props.startAmount ? props.startAmount : props.minAmount
        );
        const displayError = ref(false);

        watch(amount, (value) => {
            props.setAmount(value, props.sku);
        });

        const preventWrongInput = function () {
            if (props.doNotUseInputValidation)
                return

            let max = parseInt(props.maxAmount)
            let min = parseInt(props.minAmount)

            if (amount.value > max) {
                displayError.value = "max-error";
                props.displayMessage(displayError.value);

                return true;
            }

            if (amount.value < min) {
                displayError.value = "min-error";
                props.displayMessage(displayError.value);
                return true;
            }

            displayError.value = false;
            props.displayMessage(displayError.value);
        };

        onMounted(() => {
            preventWrongInput();
        });

        return {
            amount,
            displayError,
            preventWrongInput,
        };
    },
};
